"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_guid_1 = require("dyna-guid");
var AcknowledgeManager = /** @class */ (function () {
    function AcknowledgeManager(config) {
        this.config = config;
        this.acknowledges = {};
        this.messageIds = {}; // string = acknowledgeId
    }
    Object.defineProperty(AcknowledgeManager.prototype, "stats", {
        get: function () {
            return {
                acknowledgeIds: Object.keys(this.acknowledges),
                messageIds: Object.keys(this.messageIds),
            };
        },
        enumerable: true,
        configurable: true
    });
    AcknowledgeManager.prototype.clear = function () {
        var _this = this;
        Object.keys(this.acknowledges)
            .map(function (id) { return _this.acknowledges[id]; })
            .forEach(function (acknowledge) {
            clearTimeout(acknowledge.timer);
        });
        this.acknowledges = {};
        this.messageIds = {};
    };
    // Returns true if the message will be resolved by the AcknowledgeManager
    AcknowledgeManager.prototype.outgoingMessage = function (message, resolve, reject) {
        var _this = this;
        // The outgoing message requires Acknowledge since the dynaNodeAckTimeout is defined
        // Create an item in the dictionary, set a timer for it, and reject when the timer expires.
        if (message.headers.dynaNodeAckTimeout &&
            message.command !== 'dyna-node/ack') {
            message.headers.dynaNodeAckId = dyna_guid_1.guid();
            var timer = setTimeout(function () {
                reject({
                    code: 133.144,
                    section: 'DynaNodeClient/AcknowledgeHandling',
                    message: "Acknowledge: The message couldn't be delivered in " + message.headers.dynaNodeAckTimeout + "ms timeout.",
                });
                delete _this.acknowledges[message.headers.dynaNodeAckId || '']; // The fallback it is just for TS
                if (message.replyOf)
                    delete _this.messageIds[message.replyOf.id];
            }, message.headers.dynaNodeAckTimeout);
            this.acknowledges[message.headers.dynaNodeAckId] = {
                message: message,
                resolve: resolve,
                reject: reject,
                timer: timer,
            };
            this.messageIds[message.id] = message.headers.dynaNodeAckId;
            return true;
        }
        return false;
    };
    // Returns true if the message was for an Acknowledge.
    AcknowledgeManager.prototype.incomingMessage = function (message) {
        var _this = this;
        // Incoming message is a reply of a Acked message, that it's Ack is not recevied yet.
        // This is happening since Ack confirmation and Reply are triggered on the same time, so we have race condition.
        if (message.replyOf && this.messageIds[message.replyOf.id]) {
            var dynaNodeAckId = this.messageIds[message.replyOf.id];
            this.removeAcknowledge(dynaNodeAckId);
            return false; // Return false because this is not a message Acknowledgement
        }
        // Incoming message requires Acknowledge
        // Send the Acknowledge, nothing else
        if (message &&
            message.headers &&
            message.headers.dynaNodeAckId) {
            var dynaNodeClient = this.config.dynaNodeClient;
            dynaNodeClient.send({
                to: message.from,
                command: 'dyna-node/ack',
                args: {
                    dynaNodeAckId: message.headers.dynaNodeAckId,
                },
            })
                .catch(function () { return undefined; }); // Swallow the error
            return false; // Return false because this is not a message Acknowledgement, Its a message that required IAcknowledgement
        }
        // Incoming message is IAcknowledgement of a message that is send from this client
        // Resolve the Acknowledge and clean up
        if (message &&
            message.command === 'dyna-node/ack') {
            setTimeout(function () {
                _this.removeAcknowledge(message.args.dynaNodeAckId);
            }, this.config._debug_dynaNodeAckResolveAfter || 0);
            return true;
        }
        return false;
    };
    AcknowledgeManager.prototype.removeAcknowledge = function (dynaNodeAckId) {
        var _this = this;
        var acknowledge = this.acknowledges[dynaNodeAckId];
        if (!acknowledge)
            return;
        clearTimeout(acknowledge.timer);
        delete this.acknowledges[dynaNodeAckId];
        Object.keys(this.messageIds)
            .forEach(function (messageId) {
            if (_this.messageIds[messageId] === dynaNodeAckId)
                delete _this.messageIds[messageId];
        });
        acknowledge.resolve(acknowledge.message);
    };
    return AcknowledgeManager;
}());
exports.AcknowledgeManager = AcknowledgeManager;
//# sourceMappingURL=AcknowledgeManager.js.map